import * as _ from 'lodash';
import { localizationHelper, notificationHelper } from 'helpers';
import { userServices } from 'services';
import { AxiosError } from 'axios';
import i18next from 'i18next';

const STATUS_SUCCESS = 'success';

class LogicError extends Error {
  constructor(
    public code: string | undefined,
    message: string,
    public extra: any,
  ) {
    super(code);
  }
}

const normalizeParams = (params: any) =>
  Object.entries(params).reduce((accum, param) => {
    const [key, value] = param;
    if (value && value !== 'all') {
      const obj = { ...accum };
      obj[key] = value;
      return obj;
    }
    return accum;
  }, {});

const handleRequestError = (error: AxiosError) => {
  const status = error && error.response && error.response.status;
  switch (status) {
    case 401:
      if (error.response?.config.url === '/login') {
        notificationHelper.error(
          i18next.t(`error.${error.response.data.message}`),
        );
        return;
      }

      userServices.logout();

      break;
    case 403:
      userServices.denyAccess();
      break;
    default: {
      if (
        error.response &&
        error.response.data &&
        error.response.data.statusCode
      ) {
        const { data } = error.response;
        const { message, statusCode, error: errorField } = data;

        const title = localizationHelper.localize(statusCode);

        if (statusCode === 400) {
          const des = `${i18next.t(`error.${message}`)}`;
          notificationHelper.error(title || errorField, des);
          return;
        }

        notificationHelper.error(
          title,
          i18next.t(`error.${message}`, {
            fallbackLng: i18next.t('message.errorCommon'),
          }),
        );
      } else {
        notificationHelper.error(
          'Network request failed',
          `Network status ${status}`,
        );
      }
    }
  }
};

const handleRequestSuccess = (data: any) => {
  if (data.code && data.code !== STATUS_SUCCESS) {
    const title = localizationHelper.localize(data.code);
    const { message } = data;
    notificationHelper.error(title, message);
    throw new LogicError(data.code, message, data.extra);
  }
};
export default {
  normalizeParams,
  handleRequestError,
  handleRequestSuccess,
};
